import dayjs from 'dayjs';
import { LOCAL_TIME_ZONE, STATUS } from '../../../../../../constants';
import { getTimeZoneGuess } from '../../../../../../utils';

export const getEventsByTrainingType = (events, trainingType, listActiveSeatByUser, awaitingOrderItems) => {
     const timezoneSelected = localStorage.getItem(LOCAL_TIME_ZONE) || getTimeZoneGuess();
     const today = dayjs().tz(timezoneSelected);

     switch (trainingType) {
          case 'UpcomingTrainingEvents':
               return events
                    .filter((event) => {
                         const eventStartAt = event.startAt ? dayjs(event.startAt).tz(timezoneSelected) : null;
                         const eventEndAt = event.endAt ? dayjs(event.endAt).tz(timezoneSelected) : null;
                         const checkEventDay = !eventStartAt || eventStartAt > today || !eventEndAt || eventEndAt >= today;

                         const checkEventStatus = event.status === STATUS.ENABLE;

                         const checkRemainingSeats =
                              event.remainingSeats === null || event.remainingSeats > 0 || (event.remainingSeats === 0 && !eventStartAt);

                         if (event.course && ((checkEventDay && checkEventStatus && checkRemainingSeats) || eventEndAt >= today)) {
                              return true;
                         }

                         return false;
                    })
                    .sort((a, b) => {
                         if (a.startAt === null || b.startAt === null) {
                              return new Date(b.startAt) - new Date(a.startAt);
                         }
                         return new Date(a.startAt) - new Date(b.startAt);
                    });

          case 'PassTrainingEvents':
               return events
                    .filter((event) => {
                         const eventEndAt = event.endAt ? dayjs(event.endAt).tz(timezoneSelected) : null;

                         if (event.course && eventEndAt && eventEndAt < today && event.status === STATUS.ENABLE) {
                              return true;
                         }

                         return false;
                    })
                    .sort((a, b) => {
                         if (a.startAt === null || b.startAt === null) {
                              return new Date(b.startAt) - new Date(a.startAt);
                         }
                         return new Date(a.startAt) - new Date(b.startAt);
                    });

          case 'PurchaseAdditional':
          default:
               return events
                    .filter((event) => {
                         const isHasSeat = listActiveSeatByUser?.some((seat) => seat.eventId === event.id && seat.productId === event.productId);
                         const isHasAwaitingItem = awaitingOrderItems?.some((item) => item.eventId === event.id);

                         const eventEndAt = event.endAt ? dayjs(event.endAt).tz(timezoneSelected) : null;
                         const eventStartAt = event.startAt ? dayjs(event.startAt).tz(timezoneSelected) : null;

                         const isNotExist = !isHasSeat && !isHasAwaitingItem && !event.course;
                         const isEnableToBuy = event.status === STATUS.ENABLE && !event.isPrivate;
                         const isFutureEvent = eventStartAt && eventStartAt >= today && eventEndAt && eventEndAt >= today;
                         const isHasSeatsLeft = event.remainingSeats === null || event.remainingSeats > 0;

                         if (isNotExist && isEnableToBuy && isFutureEvent && isHasSeatsLeft) {
                              return true;
                         }

                         return false;
                    })
                    .sort((a, b) => {
                         if (a.endAt === null || b.endAt === null) {
                              return new Date(b.endAt) - new Date(a.endAt);
                         }
                         return new Date(a.endAt) - new Date(b.endAt);
                    });
     }
};
